import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { locale as italian } from "../../../../i18n/it";
import { SkillsService } from "../../../../auth/service/skills.service";
import skillLevels from "../../../../auth/models/skill-levels";
import languageLevels from "../../../../auth/models/language-levels";
import worldLanguages from "../../../../auth/models/languages";
import { UtilsService } from "../../../../auth/service/utils.service";
import { EducationTitleService } from "../../../../auth/service/education-title.service";
import { CertificationService } from "../../../../auth/service/certification.service";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { HttpClient } from "@angular/common/http";
import { WorkDomainService } from "../../../../auth/service/work-domain.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EducationSubjectService } from "../../../../auth/service/education-subject.service";
import moment from "moment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-curriculum",
  templateUrl: "./user-curriculum.component.html",
  styleUrls: ["./user-curriculum.component.scss"],
})

export class UserCurriculumComponent implements OnInit {
  public active_table: string = "experience";
  public contentHeader: IContentHeader;
  public currentUser: any = {};
  public is_my_profile: boolean;
  public me: ICurrentUser;
  public skills_list: any = [];
  public skill_levels: object[] = skillLevels;
  public language_levels: string[] = languageLevels;
  public languages_list: string[] = worldLanguages;
  public languages_levels_description: string = "";
  public indexOfItemSkill: number = 0;
  public items_certifications: any = [];
  public items_experiences: any = [];
  public items_skills: any = [];
  public items_education: any = [];
  public items_languages: any = [];
  public new_skill: string;
  public new_certificate: string;
  public indexOfItemCertifications: number = 0;
  public skillNotDeletable: Array<number> = [];
  public today: any = moment().format("MM-DD-YYYY");
  public skillToPropose: Array<any> = [];
  public saveFirst: boolean = false;
  public skillWaitingToApprove: Array<any> = [];

  constructor(
    private _httpClient: HttpClient,
    public _utilService: UtilsService,
    public _userService: UserService,
    public _skillService: SkillsService,
    private _changeDetector: ChangeDetectorRef,
    public _educationTitleService: EducationTitleService,
    public _authenticationService: AuthenticationService,
    public _certificationService: CertificationService,
    public _userFigureService: UserFigureService,
    private activated_route: ActivatedRoute,
    public _workDomainService: WorkDomainService,
    public _modalService: NgbModal,
    public _educationSubjectService: EducationSubjectService,
    public _router: Router,
  ) {
    this.me = this._authenticationService.getCurrentUser();

    this._utilService.disableAutoHideLoading();

    this.activated_route.paramMap.subscribe(async (params: ParamMap) => {
      const userIdentifier: any = params.get("user_identifier");
      this.is_my_profile = this.me.hash === userIdentifier;

      if (!_authenticationService.hasCapability("view_others_curriculum") && !this.is_my_profile) {
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      }

      if (userIdentifier) {
        await this.loadUserData(userIdentifier);
      }
    });
  }

  async ngOnInit() {
    await this._skillService.getList();
    this.skills_list = this._skillService.list;
    await this._educationTitleService.getList();
    await this._educationSubjectService.getList();
    await this._workDomainService.getList();

    this.language_levels.map(async (level: string) => {
      const title: string = await this._utilService.translate("LANGUAGE_LEVELS." + level + ".LABEL").then((str) => `${level} - ${str}`);
      const description: string = await this._utilService.translate("LANGUAGE_LEVELS." + level + ".DESCRIPTION");
      this.languages_levels_description += `${title}:${description}\n`;
    });
    this._utilService.hideLoading();
  }

  async loadUserData(identifier: any) {
    this.currentUser = await this._userService.get(identifier).catch(async () => {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    });
    if (!this.currentUser) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    //Controllo per i collaboratori se l'utente è un collaboratore non potrà accedere a questa pagina
    if (this._utilService.isACollaborator(this.currentUser)) {
      this._utilService.hideLoading();
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.currentUser.skills = this.currentUser.skills.map((skill) => {
      this.items_skills.push({
        skill: skill.skill_id,
        level: skill.level,
        primary: skill.primary,
        enabled: skill.enabled,
      });
    });

    let skillNotApproved: any = [];
    this.currentUser.experiences.map((exp: any) => {
      /*Aggiungiamo un array vuoto per inserire le skill approvate che l'utente ha inserito nelle sue esperienze*/
      exp.tecnologyApproved = [];
      exp.tecnologyWaitingToApprove = [];
    });

    this.currentUser.experiences.map((exp: any, index: number) => {
      /*Qui inseriamo le skill nell' array*/
      if (exp.skill_ids && exp.skill_ids.length > 0) {
        exp.skill_ids.map((skillEmployee: any) => {
          const isAnApprovedSkill: any = this._skillService.list_enabled.find((skill: any) => skill.id === Number(skillEmployee));
          if (isAnApprovedSkill) {
            exp.tecnologyApproved.push(skillEmployee);
            this.currentUser.experiences[index] = exp;
          } else {
            skillNotApproved.push(skillEmployee);
            exp.tecnologyWaitingToApprove.push(skillEmployee);
          }
        });
      }
    });

    /*Per ogni esperienza che l'utente ha salvato in database creiamo un nuovo item in items_experiences*/
    this.currentUser.experiences.map((exp: any) => {
      this.items_experiences.push({
        from: exp.from ? moment(exp.from).format("YYYY-MM-DD") : null,
        to: exp.to ? moment(exp.to).format("YYYY-MM-DD") : null,
        agency: exp.agency ? exp.agency : null,
        description: exp.description ? exp.description : null,
        domain: exp.domain ? exp.domain : null,
        tecnologyApproved: exp.tecnologyApproved ? exp.tecnologyApproved : null,
        tecnology: [],
        tecnologyWaitingToApprove: exp.tecnologyWaitingToApprove ? exp.tecnologyWaitingToApprove : null,
        figure: exp.figure_id ? exp.figure_id : null,
        isCurrentExperience: !exp.to,
        customer: exp.customer ? exp.customer : null,
      });
    });
    skillNotApproved.map((skill) => {
      /*Qui inseriamo le skill che sono in attesa di approvazione*/
      const skillToApprove = this._skillService.list.find((item) => item.id === skill);
      if (skillToApprove) {
        this.skillWaitingToApprove.push(skillToApprove);
      }
    });

    // se c'è qualche esperienza creo un array d' ID di skills prendendole dalle tecnologie inserite
    if (this.currentUser.experiences && this.currentUser.experiences.length > 0) {
      this.currentUser.experiences.map((exp: any) => {
        if (exp.skill_ids) {
          exp.skill_ids.map((skill_id: number) => {
            skill_id = Number(skill_id);
            this.skillNotDeletable.push(Number(skill_id));
            const alreadyAdded: any = this.items_skills.find((skill: any) => Number(skill.skill) === skill_id);
            if (!alreadyAdded) {
              this.items_skills.push({
                skill: skill_id,
                level: "junior",
                enabled: 1,
              });
            }
          });
        }
      });
    }
    this.items_skills = [
      ...this.items_skills.filter((skill: any) => skill.level === "senior"),
      ...this.items_skills.filter((skill: any) => skill.level === "middle"),
      ...this.items_skills.filter((skill: any) => skill.level === "junior"),
    ];
    if (this.currentUser.educations && this.currentUser.educations.length > 0) {
      this.currentUser.educations.map((item: any) => {
        this.items_education.push({
          title_id: item.title_id,
          subject: item.title_name === "Laurea" ? item.graduate_id : item.subject,
          vote: item.vote,
          current: item.current,
          primary: item.primary,
          name: item.title_name,
        });
      });
    }

    this.items_languages = this.currentUser.languages.map((i) => i);
    this.items_certifications = this.currentUser.certifications.map((i) => i);
    this.addSkillItem();
    this.addExperienceItem();
    this.addLanguageItem();
    this.addEducationItem();
    this.addCertificationItem();

    const headerBreadcrumbs: any = [];

    if (!this.is_my_profile) {
      headerBreadcrumbs.push({
        name: italian.data.TITLES.USERS,
        isLink: true,
        link: `/dashboard/user/list/${this.currentUser.type_code}`,
      });
      headerBreadcrumbs.push({
        name: this.currentUser.firstname + " " + this.currentUser.lastname,
        isLink: true,
        link: `/dashboard/user/profile/${this.currentUser.hash}`,
      });
    } else {
      headerBreadcrumbs.push({
        name: italian.data.TITLES.PROFILE,
        isLink: true,
        link: `/dashboard/user/profile/${this.currentUser.hash}`,
      });
    }

    headerBreadcrumbs.push({
      name: "Curriculum",
      isLink: false,
    });

    this.contentHeader = {
      headerTitle: italian.data.TITLES.CURRICULUM,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: headerBreadcrumbs,
      },
    };

    this._changeDetector.detectChanges();
  }

  addExperienceItem() {
    this.items_experiences.push({
      from: "",
      to: "",
      agency: "",
      customer: "",
      description: "",
      domain: "",
      tecnology: [],
      tecnologyApproved: [],
      tecnologyWaitingToApprove: [],
      figure: null,
      isCurrentExperience: false,
    });
  }

  removeExperienceItem(index: number) {
    /*Oltre a rimuovere l' oggetto specifico dell' array d' items_experiences svuotiamo skillToPropose[Array] che contiene soltanto le skill proposte, per poi ripopolarlo*/
    delete this.items_experiences[index];
    this.skillToPropose = [];
    this.items_experiences.map((item: any) => {
      if (item.tecnologyApproved && item.tecnologyApproved.length > 0) {
        this.skillToPropose.push({
          skill: item.tecnologyApproved.filter((techApproved: any) => typeof techApproved === "string"),
        });
      }
    });
    this.items_experiences = this.items_experiences.filter((i) => i);
    if (this.items_experiences.length == 0) {
      this.addExperienceItem();
    }
  }

  addSkillItem() {
    this.items_skills.push({ skill: 0, level: "", enabled: true });
  }

  removeSkillItem(index: number) {
    delete this.items_skills[index];
    this.items_skills = this.items_skills.filter((i) => i);
  }

  addEducationItem() {
    this.items_education.push({ name: null, title_id: 0, subject: null, vote: null, current: false, primary: false });
  }

  removeEducationItem(index: number) {
    delete this.items_education[index];
    this.items_education = this.items_education.filter((i) => i);
  }

  cancelVote(i: number) {
    if (this.items_education[i].current) {
      this.items_education[i].vote = null;
    }
  }

  onSetPrimarySkill(skill: any, i: number) {
    if (skill.primary) {
      this.items_skills.map((value: any, index: number) => {
        if (index !== i) {
          this.items_skills[index].primary = false;
        }
      });
    }
  }
  onSetPrimaryEducation(education: any, i: number) {
    if (education.primary) {
      this.items_education.map((value: any, index: number) => {
        if (index !== i) {
          this.items_education[index].primary = false;
        }
      });
    }
  }
  addLanguageItem() {
    this.items_languages.push({ name: "", speak: "", write: "" });
  }

  removeLanguageItem(index: number) {
    delete this.items_languages[index];
    this.items_languages = this.items_languages.filter((i) => i);
    if (this.items_languages.length < 1) {
      this.addLanguageItem();
    }
  }

  addCertificationItem() {
    this.items_certifications.push({ cert_id: 0 });
  }

  removeCertificationItem(index: number) {
    delete this.items_certifications[index];
    this.items_certifications = this.items_certifications.filter((i) => i);
  }

  async save() {
    //Rimuovo eventuali spazi
    this.items_education.map((item) => {
      if (!!item.subject && typeof item.subject === "string") {
        item.subject = item.subject.trim();
      }
      if (!!item.vote) {
        item.vote = item.vote.trim();
      }
    });

    // creo un array data con gli array di skills, languages ed experiences filtrati così da prendere solo i capi riempiti dall'utente e non quello vuoto
    let data: any = {
      skills: this.items_skills.filter((i) => (i.skill.length || i.skill > 0) && i.level.length > 0),
      languages: this.items_languages.filter((i) => i.name.length > 0 && i.speak.length > 0 && i.write.length > 0),
      educations: this.items_education.filter((i) => !!i.title_id && !!i.subject),
      experiences: this.items_experiences.filter((i) => i.from || i.agency || i.description || i.domain || i.figure || i.tecnologyApproved.length > 0 || i.tecnologyWaitingToApprove.length > 0),
      certifications: this.items_certifications
        .filter((i) => i.cert_id > 0 || i.cert_id.length > 0)
        .map((cert: any) => {
          return {
            cert_id: cert.cert_id,
          };
        }),
    };
    //Controllo per formazione
    if (!data.educations || data.educations.length < 1) {
      this.active_table = "education";
      setTimeout(() => {
        document.getElementById("education-card").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
      await this._utilService.showSWALError({ text: "COMPLETE_EDUCATION_SECTION" });
      return false;
    }
    const checkEducationPrimary = data.educations.filter((skill: any) => skill.primary);
    if (checkEducationPrimary.length < 1) {
      this.active_table = "education";
      setTimeout(() => {
        document.getElementById("education-card").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
      return this._utilService.showSWALError({ text: "SELECT_PRIMARY_EDUCATION" });
    }
    /*Prendiamo le tecnologie di tecnologyApproved e tecnologyWaitingToApprove le mettiamo in tecnology e rimuoviamo i possibili doppioni*/
    data.experiences.map((item: any) => {
      item.tecnology = item.tecnology.concat(item.tecnologyApproved).concat(item.tecnologyWaitingToApprove);
      item.tecnology = item.tecnology.filter(function (value: any, pos: number, self: any) {
        return self.indexOf(value) == pos;
      });
    });
    /*Inizio controllo per Esperienze*/
    let showedError: boolean = false;
    if (!data.experiences || data.experiences.length === 0) {
      showedError = false;
    } else if (data.experiences && data.experiences.length > 0) {
      data.experiences.map(async (exp: any) => {
        if (
          /*In caso l'esperienza non sia corrente teniamo conto della variabile exp.to come obbligatoria*/
          exp.isCurrentExperience &&
          !!exp.from &&
          !!exp.to &&
          !!exp.agency &&
          !!exp.description &&
          !!exp.domain &&
          !!exp.figure &&
          exp.tecnology.length < 1 &&
          !showedError
        ) {
          showedError = false;
        }
        if (
          /*In caso l'esperienza sia corrente non teniamo conto della variabile exp.to come obbligatoria*/
          ((!exp.isCurrentExperience && !exp.to) || !exp.from || !exp.agency || !exp.description || !exp.domain || !exp.figure || exp.tecnology.length < 1) &&
          !showedError
        ) {
          showedError = true;
          await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_FIELDS_EMPTY" });
        }
      });
    }
    if (showedError) {
      await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_FIELDS_EMPTY" });
      return false;
    }

    /*Cancelliamo isCurrentExperience, tecnologyApproved e tecnologyWaitingToApprove da tutti gli oggetti dell' array in quanto al backend sono dati superflui*/
    data.experiences = data.experiences.map(({ isCurrentExperience, tecnologyApproved, tecnologyWaitingToApprove, ...rest }) => ({ ...rest }));

    /*Fine controllo per Esperienze*/

    const checkSkillPrimary = data.skills.filter((skill: any) => skill.primary);
    if (checkSkillPrimary.length < 1) {
      this.active_table = "skill";
      setTimeout(() => {
        document.getElementById("skill-card").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
      return this._utilService.showSWALError({ text: "SELECT_PRIMARY_SKILL" });
    }

    data.skills.map((skill: any) => {
      skill.primary = skill.primary ? 1 : 0;
    });

    // se l' array delle lingue è vuoto lo rimuovo da data
    if (JSON.stringify(data.languages) === JSON.stringify(this.currentUser.languages)) delete data.languages;
    // se l' array delle esperienze è vuoto lo rimuovo da data
    if (JSON.stringify(data.experiences) === JSON.stringify(this.currentUser.experiences)) delete data.experiences;
    // se l' array delle certificazioni è vuoto lo rimuovo da data
    if (JSON.stringify(data.certifications) === JSON.stringify(this.currentUser.certifications)) delete data.certifications;
    // se l' array della formazione è vuoto lo rimuovo da data
    if (JSON.stringify(data.educations) === JSON.stringify(this.currentUser.educations)) delete data.educations;

    if (Object.keys(data).length < 1) {
      //Niente da aggiornare
      return this._utilService.showSWAL({
        title: "ALERT_TITLE",
        text: "NOTHING_TO_UPDATE",
        icon: "warning",
        confirmButtonText: "BTN_CLOSE",
        showCancelButton: false,
        customClass: {
          confirmButton: "btn btn-warning",
        },
      });
    }
    //check duplicate skills
    const checkedArray = this.items_skills.reduce((unique, o) => {
      if (!unique.some((obj) => obj.skill === o.skill)) {
        unique.push(o);
      }

      return unique;
    }, []);
    if (this.items_skills.length !== checkedArray.length) {
      this.active_table = "skill";
      setTimeout(() => {
        document.getElementById("skill-card").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
      await this._utilService.showSWALError({ text: "ERROR_DUPLICATE_SKILL" });
      return false;
    }
    //END check duplicate skills

    //check duplicate certifications
    const checkedArrayCertifications = this.items_certifications.reduce((unique, o) => {
      if (!unique.some((obj) => obj.cert_id === o.cert_id)) {
        unique.push(o);
      }

      return unique;
    }, []);
    if (this.items_certifications.length !== checkedArrayCertifications.length) {
      this.active_table = "education";
      setTimeout(() => {
        document.getElementById("education-card").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center",
        });
      });
      await this._utilService.showSWALError({ text: "ERROR_DUPLICATE_CERTIFICATIONS" });
      return false;
    }
    //END check duplicate certifications
    this._utilService.showLoading();
    return this._userService
      .update(this.currentUser.hash, data)
      .then(async () => {
        if (data.skills) {
          //showSWAL Skill da approvare
          const newSkillControl = data.skills.filter((i) => i.enabled === 0);
          if (newSkillControl.length > 0) {
            this._utilService.hideLoading();
            await this._utilService.showSWALSuccess({ text: "SKILL_TO_APPORVE" });
          }
        }
        if (data.certifications) {
          //showSWAL Certificato da approvare
          const newCertificateControl = data.certifications.filter((i) => typeof i.cert_id === "string");
          if (newCertificateControl.length > 0) {
            this._utilService.hideLoading();
            await this._utilService.showSWALSuccess({ text: "CERTIFCATE_TO_APPORVE" });
          }
        }
        this.items_skills = [];
        this.items_experiences = [];
        this.items_education = [];
        this.skillToPropose = [];
        this.items_certifications = [];
        this.skillNotDeletable = [];
        this.skillWaitingToApprove = [];
        await this._skillService.getList();
        await this.loadUserData(this.currentUser.hash);
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "USER_UPDATE_CORRECT" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "USER_UPDATE_ERROR" });
        return false;
      });
  }

  generateCV() {
    return this._httpClient
      .get(`/genera-cv-aziendale/${this.currentUser.hash}`)
      .toPromise()
      .then(async (response: any) => {
        if (response.length > 0) {
          return this._utilService.showSWALError({ text: "ERROR_GENERATE_CV" });
        }
        return this._utilService.showSWALSuccess({ text: "SUCCESS_GENERATE_CV" }).then(async (result: any) => {
          if (result.value) {
            window.open(response.url, "_blank");
          }
        });
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_GENERATE_CV" }));
  }

  public modalOpen(modalBasic, index: number) {
    this.new_skill = "";
    this.new_certificate = "";
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.indexOfItemSkill = index;
  }

  async filterSKillList() {
    return (this.items_skills = this.items_skills = this.items_skills.filter((i) => ((i.skill && i?.skill.length > 0) || i?.skill > 0) && i?.level.length > 0));
  }

  async addSkillToPropose() {
    /*Funzione per aggiungere una skill all' array di skill che l'utente può proporre(skillToPropose)*/
    if (this.new_skill == null) {
      await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" });
      return false;
    }
    /*Controllo che la skill non sia già presente nel nostro database*/
    const skillAlreadyExists = this.skills_list.find((skill) => skill.name == this.new_skill.trim());
    if (skillAlreadyExists) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST_IN_DATABASE" });
      this.new_skill = "";
      return false;
    }
    /*Fine Controllo che la skill non sia già presente nel nostro database*/

    /*Controllo che la skill non sia già presente nelle sue skill*/
    let skillAlreadyProposed = false;
    this.items_experiences.map(async (item: any) => {
      if (item.tecnology.includes(this.new_skill)) {
        this.new_skill = "";
        skillAlreadyProposed = true;
      }
    });
    if (skillAlreadyProposed) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST" });
      return false;
    }
    this.skillToPropose = []; /*Ogni volta inizializziamo this.skillToPropose per poi popolarlo*/
    /*Aggiungiamo a tecnologyApproved la skill proposta che a differenza delle altre sarà una string proposta dall'utente*/
    this.items_experiences[this.indexOfItemSkill].tecnology.push(this.new_skill);
    this.items_experiences.map((item: any) => {
      if (item.tecnology) {
        this.skillToPropose.push({
          skill: item.tecnology.filter((tech: any) => typeof tech === "string"),
        });
      }
    });
    /*Resettiamo la variabile new skill*/
    this.new_skill = "";
    this.indexOfItemSkill = 0;
  }

  async addModalObjectSkill() {
    if (this.new_skill == null) {
      await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" });
      return false;
    }
    const skillAlreadyExists = this.skills_list.find((skill) => skill.name === this.new_skill.trim());
    if (skillAlreadyExists) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST_IN_DATABASE" });
      this.new_skill = "";
      return false;
    }
    this.items_skills.push({
      skill: this.new_skill,
      level: "junior",
      enabled: 0,
      isNew: 1,
    });
    let alreadyExists: any = this.items_skills.filter((item) => item.skill == this.new_skill);
    if (alreadyExists && alreadyExists.length > 1) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST" });
      this.items_skills.splice(this.indexOfItemSkill, this.indexOfItemSkill + 1);
      this.new_skill = "";
      return false;
    }

    this.new_skill = "";
    this.items_skills = await this.filterSKillList();
  }

  async filterCertificationList() {
    return (this.items_certifications = this.items_certifications.filter((i) => i.cert_id.length > 0 || i.cert_id > 0));
  }

  async addModalObjectCertification() {
    if (this.new_certificate == undefined) {
      await this._utilService.showSWALError({ text: "ERROR_EXPERIENCES_INSERT" });
      return false;
    }
    this.items_certifications.push({
      cert_id: this.new_certificate,
      isNew: 1,
      enabled: 0,
    });
    this.new_certificate = "";
    if (this.items_certifications[this.indexOfItemCertifications].cert_id.length < 1) {
      this.items_certifications.splice(this.indexOfItemCertifications, 1);
    }
    this.items_certifications = await this.filterCertificationList();
  }

  /*Funzione per controllare se una skill è gia stata inserita dall'utente*/

  async checkIfAlreadyInsertedSkill(value: any, index: number) {
    if (value === undefined) {
      return false;
    }
    let alreadyExists: any = this.items_skills.filter((item) => item.skill == value.id);
    if (alreadyExists && alreadyExists.length > 1) {
      await this._utilService.showSWALError({ text: "ERROR_SKILL_ALREADY_EXIST" });
      this.items_skills.splice(index, index + 1);
      return false;
    }
  }

  /*Funzione che controlla se ci sono skill suggerite cosi da bloccare il cambio tab*/
  async proposedSkillCheck(goTo: any) {
    let checkSkillInserted: any = [];
    if (this.active_table === "experience") {
      await this.items_experiences.map(async (expItem: any) => {
        if (expItem.tecnology && expItem.tecnology.length > 0) {
          await expItem.tecnology.map((techItem: any) => {
            this.saveFirst = typeof techItem === "string";
            if (this.saveFirst) {
              checkSkillInserted.push(techItem);
            }
          });
        }
      });
    }
    if (this.active_table === "skill") {
      if (this.items_skills && this.items_skills.length > 0) {
        this.items_skills.map((skillItem: any) => {
          this.saveFirst = typeof skillItem.skill === "string";
          if (this.saveFirst) {
            checkSkillInserted.push(skillItem);
          }
        });
      }
    }
    if (checkSkillInserted && checkSkillInserted.length > 0) {
      await this._utilService.showSWALError({ text: "SAVE_FIRST_YOUR_PROPOSED_SKILL" });
      return false;
    } else {
      this.active_table = goTo;
    }
  }
}
